import React, { useEffect, useState } from 'react'
import styled from 'styled-components';
import NavBarPrimary from '../../Components/layout/headers/NavBarPrimary';
import { isActive, IsTablet, isFreeUser } from '../../Utils/UtilityFunctions';
import DrawerAlerts from '../../Components/alerts/components/DrawerAlerts';
import AccountPopOver from '../../Components/common/components/AccountPopOver';
import GlobalSearch from '../../Components/globalSearch/components/GlobalSearch';
import GlobalButton from '../../Components/common/components/GlobalButton';
import { useNavigate, useSearchParams } from 'react-router-dom';
import BackIcon from '../../Components/common/assets/svgIcons/BackIcon';
import { maxWidth, retina, retinaOne, maxMobile, secondaryFont, primaryHeadingColor, wMedium, SecondaryColor, primaryColor, greyColor, primaryFont } from '../../Utils/utilsStyle';
import EditIcon from '../../Components/company/svgIcons/EditIcon';
import ExportIcon from '../../Components/common/assets/svgIcons/ExportIcon';
import { actions as companiesActions } from '../../Slice/CompaniesSlice';
import { useDispatch, useSelector } from 'react-redux';
import { selectCompanies, selectedSortingType } from '../../Selector/CompaniesSelector';
import { Company } from '../../Types/CompaniesTypes';
import { Checkbox, Col, Row } from 'antd';
import CompanyCardLarge from '../../Components/common/components/CompanyCardLarge';
import BinIcon from '../../Components/company/svgIcons/BinIcon';
// import CompaniesSection from 'Components/company/components/CompaniesSection';
import { actions as clusterActions } from '../../Slice/ClustersSlice';
import { selectAllClusterCompanies, selectAllClusterCompanyCount, selectClusterDrawerOpen, selectClusterName, selectClusterShared, selectClustersShared, selectDetailsLoading, selectSharedByFirstName } from '../../Selector/ClustersSelector';
import DrawerAccountCluster from '../../Components/company/components/DrawerAccountCluster';
import { selectShowGlobalGilroy } from '../../Selector/GlobalSearchContentSelector';
import { useGilroy } from '../../Utils/hooks/useGilroy';
import { Gilroy } from '../../Components/gilroy/LazyGilroy';
import DrawerPeopleGroup from '../../Components/people/components/DrawerPeopleGroup';
import ShareGroupPeopleModal from '../../Components/common/modal/ShareGroupPeopleModal';
import SharedBadge from '../../Components/common/components/SharedBadge';
import CompaniesSvg from '../../Components/layout/assets/CompaniesSvg';
import ClusterInsightSection from './ClusterInsightSection';
import { SelectedCompany } from '../../Types/ClustersTypes';
import { flushSync } from 'react-dom';
const Wrapper = styled.div`
  padding-bottom: 150px;
.fancy-box {
  border-radius: 22px;
  background: rgb(255, 255, 255);
  padding: 40px 50px 40px 50px;
  margin-top: 50px;
  box-shadow: 0 0 17px -2px rgba(0, 0, 0, 0.04);
  @media all and (max-width: ${maxWidth}) , ${retina} {
    padding: 17px 25px 25px 25px;
  }
  @media all and (max-width: ${maxWidth}) , ${retinaOne} {
    padding: 17px 25px 25px 25px;
  }
  @media all and (max-width: ${maxMobile}) {
    padding: 17px 16px 16px 16px;
  }
  .header-section {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 22px;
    .left-section {
      h1 {
        color: ${primaryHeadingColor};
        font-family: ${secondaryFont};
        font-size: 24px;
        font-weight: ${wMedium};
        line-height: 30px;
        letter-spacing: -0.4px;
        margin-bottom: 0;
        column-gap: 8px;
        @media all and (max-width: ${maxWidth}) , ${retina} {
          font-size: 19px;
        }
      }
    }
    .right-section {
      display: flex;
      align-items: center;
      justify-content: space-between;
      column-gap: 8px;
      .remove-cancel-btn-div {
        display: flex;
        align-items: center;
        column-gap: 8px;
      }
      .edit-btn {
        column-gap: 6px;
        svg {
          width: 18px;
          height: 18px;
          path {
            fill: ${SecondaryColor}
          }
        }
      }
      .share-btn-wrapper {
        display: flex;
        align-items: center;
        .share-button-group.groupPageButton {
          background-color: #fff;
          border: 1.6px solid ${SecondaryColor};
          height: auto;
          padding: 10px 16px;
          border-radius: 8px;
          color: ${SecondaryColor};
          font-family: ${primaryFont};
          font-weight: ${wMedium};
          font-size: 16px;
          line-height: normal;
          display: inline-flex;
          align-items: center;
          cursor: pointer;
          .icon-mode {
            display: inline-flex;
            align-items: center;
            column-gap: 6px;
            .icon-mode-text {
              color: ${SecondaryColor};
              font-weight: ${wMedium};
              font-family: ${primaryFont};
              font-size: 16px;
            }
            .seperator {
              border-left: 1.6px solid ${SecondaryColor};
              height: 18px;
              margin: 0 0 0 2px;
            }
            .share-icon {
              display: inline-flex;
              align-items: center;
              svg {
                height: 18px;
                width: 18px;
                g {
                  fill: ${SecondaryColor};
                }
              }
            }
          }
        }
      }
      .add-account-btn {

      }
      .apply-btn {

      }
    }
  }
  .companies-section {
    .ant-col {
      display: flex;
      align-items: center;
      justify-content: center;
      .company-card-wrapper {
        position: relative;
        width: 200px !important;
        .floating-checkbox {
          &.ant-checkbox-wrapper {
            width: auto !important;
          }
          position: absolute;
          right: -8px;
          top: 0px;
          z-index: 1;
        }
        .company-item {
          .follow-action {
            display: none;
          }
        }
      }
    }
  }
}
.not-applied-section {
  height: calc(100vh - 461px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  row-gap: 16px;
  .icon {
    svg {
      height: 50px;
      width: 50px;
      g {
        fill: #CBCBCA;
      }
      path {
        fill: #CBCBCA;
      }
    }
    
  }
  .text {
    color: #424B50;
    text-align: center;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px;
    letter-spacing: -0.4px;
    max-width: 230px;
  }
  .gilroy-loader {
    width: 156px;
    height: 156px;
  }
}
;`
const ClusterDetailPage = function ClusterDetailPage() {
  const isTab = IsTablet();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { gilroyStates, gilroyActions } = useGilroy();
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [editClicked, setEditClicked] = useState<boolean>(false);
  const [applyCompanies, setApplyCompanies] = useState<boolean>(false);
  const [selectedCompanies, setSelectedCompanies] = useState<SelectedCompany[]>([]);
  const [companiesToRemove, setCompaniesToRemove] = useState<number[]>([]);
  const [selectedStrategicHighlight, setSelectedStrategicHighlight] = useState<string | undefined>(undefined);
  const [searchParams] = useSearchParams();
  const clusterId = searchParams.get('clusterId');
  const clusterIdParsed = clusterId ? parseInt(clusterId, 10) : 0;
  const detailsLoading = useSelector(selectDetailsLoading);
  // const clusterId = useSelector(selectClusterId);
  const clusterName = useSelector(selectClusterName);
  const clusterShared = useSelector(selectClusterShared);
  const clustersShared = useSelector(selectClustersShared);
  const clusterCompanies: Company[] = useSelector(selectAllClusterCompanies);
  const clusterCompanyCount = useSelector(selectAllClusterCompanyCount);
  const sharedByFirstName = useSelector(selectSharedByFirstName);
  const clusterDrawerOpen = useSelector(selectClusterDrawerOpen);
  const showGlobalGilroy = useSelector(selectShowGlobalGilroy);

  useEffect(() => {
    if (!clusterIdParsed) return;
    dispatch(clusterActions.getClusterDetails({
      clusterId: clusterIdParsed,
    }));
    setApplyCompanies(false);
    setSelectedCompanies([]);
    setEditClicked(false);
    setCompaniesToRemove([]);
  }, [clusterIdParsed, dispatch]);

  useEffect(() => {
    dispatch(clusterActions.resetClusterCreationStatus(false));
  }, [dispatch]);

  useEffect(() => {
    const validCompanyIds = new Set(clusterCompanies.map((company) => company.companyId));
    setSelectedCompanies((prev) => {
      const next = prev.filter((company) => validCompanyIds.has(company.companyId));
      if (next.length === prev.length) {
        return prev;
      }
      dispatch(clusterActions.setClusterSelectedCompanies(next));
      if (next.length === 0) {
        setApplyCompanies(false);
      }
      return next;
    });
  }, [clusterCompanies, dispatch]);

  const syncSelectionAfterRemoval = (removedIds: number[]) => {
    const removedSet = new Set(removedIds);
    setSelectedCompanies((prev) => {
      const next = prev.filter((company) => !removedSet.has(company.companyId));
      dispatch(clusterActions.setClusterSelectedCompanies(next));
      if (next.length === 0) {
        setApplyCompanies(false);
      }
      return next;
    });
  };

  const editHandler = () => {
    setEditClicked(true);
  }
  const cancelHandler = () => {
    setEditClicked(false);
    setCompaniesToRemove([]);
  }

  const shareClusterHandler = (check: boolean) => {
    if (check) {
      dispatch(clusterActions.setSelectedClusters([{
        clusterName: clusterName || '',
        clusterId: clusterIdParsed,
      }]));
    }
  };

  useEffect(() => {
    if (clustersShared) {
      dispatch(clusterActions.setSelectedClusters([]));
    }
  }, [clustersShared, dispatch]);
  // const handleCompanySelect = (companyId: number) => {
  //   setSelectedCompanies((prev) => {
  //     if (prev.includes(companyId)) {
  //       return prev.filter((id) => id !== companyId)
  //     }
  //     return [...prev, companyId];
  //   });
  // };
  const handleCompanySelect = (
    companyId: number,
    companyName: string
  ) => {
    setSelectedCompanies((prev) => {
      const exists = prev.some(
        (company) => company.companyId === companyId
      );

      if (exists) {
        return prev.filter(
          (company) => company.companyId !== companyId
        );
      }

      return [
        ...prev,
        {
          companyId,
          companyName,
        },
      ];
    });
  };

  const handleCompanyRemoveSelect = (companyId: number) => {
    setCompaniesToRemove((prev) => {
      if (prev.includes(companyId)) {
        return prev.filter((id) => id !== companyId);
      }

      return [...prev, companyId];
    });
  };

  const removeHandler = () => {
    if (!companiesToRemove.length) {
      return;
    }
    const removedIds = [...companiesToRemove];
    syncSelectionAfterRemoval(removedIds);
    dispatch(clusterActions.manageAccountCluster({
      type: 'edit',
      clusterId: clusterIdParsed,
      removedCompanyIds: removedIds.join(','),
    }));
    setCompaniesToRemove([]);
    setEditClicked(false);
  };

  const applyHandler = () => {
    if (!selectedCompanies.length) {
      return;
    }
    setApplyCompanies(true);
    console.log("apply triggered:", selectedCompanies);
    dispatch(clusterActions?.setAllCompanyDetailsLoading(true));
    // dispatch(clusterActions?.resetClusterInsightData());
    dispatch(clusterActions.setClusterSelectedCompanies(selectedCompanies));
  }

  const addAccountHandler = () => {
    dispatch(clusterActions.setDrawerOpen(true));
  }

  const toggleDrawer = () => {
    dispatch(clusterActions.setDrawerOpen(!clusterDrawerOpen))
  }

  const toggle = (flag: boolean) => {
    setOpenCreateModal(flag);
  };

  const handleHighlightClick = (prompt: string) => {
    flushSync(() => setSelectedStrategicHighlight(undefined));
    setSelectedStrategicHighlight(prompt);
    // dispatch(flurryActions.callFlurryEvent(
    //   valueToObject(`company_highlights_clicked`, startTime, {
    //     companyId: companyIdParsed,
    //     company: companyProfile?.companyName,
    //     prompt,
    //   }),
    // ));
  };

  const handleGilroyClose = () => {
    setSelectedStrategicHighlight(undefined);
  };
  return (
    <Wrapper>
      <NavBarPrimary headerClassName="no-overflow-on-header">
        <div className="left-side-wrap">
          <BackIcon onClick={() => {
            navigate(-1)
            // dispatch(clusterActions.resetClusterDetails());
          }} />
          <h1 className='heading text-truncate-two-line'>Accounts Clusters</h1>
        </div>
        <div className="right-side-wrap">
          {isActive() ? (
            <>
              <GlobalSearch iconMode={isTab} />
              <DrawerAlerts />
              <AccountPopOver />
            </>
          ) : (
            <GlobalButton
              title="Login"
              textColor="#ffffff"
              bgColor="#1EC252"
              borderRadius="25px"
              innerSpace="8px 20px"
              PaddingSm="4px 16px 6px 16px"
              height="36px"
              fontSize="18px"
              fontSizeSm="16px"
              buttonClassName="button-follow"
              onButtonClick={() => navigate('/')}
            />
          )}
        </div>

      </NavBarPrimary>
      {
        !detailsLoading ? (
          <div className='container'>
            <div className='fancy-box'>
              <div className="header-section">
                <div className='left-section'>
                  <h1 className="d-flex align-items-center">
                    {`${clusterName} (${clusterCompanyCount})`}
                    {clusterShared === 1 ? (
                      <SharedBadge label={`Shared by ${sharedByFirstName || ''}`} />
                    ) : null}
                  </h1>
                </div>
                <div className='right-section'>
                  {
                    editClicked ? (
                      <div className='remove-cancel-btn-div'>
                        <GlobalButton
                          title='Remove'
                          textColor={greyColor}
                          bgColor='#fff'
                          outlineColor={greyColor}
                          innerSpace='8px 12px'
                          IconLeft={<BinIcon />}
                          onButtonClick={removeHandler}
                          disabled={companiesToRemove.length === 0}
                        />
                        <GlobalButton
                          title='Cancel'
                          textColor={greyColor}
                          bgColor='#fff'
                          outlineColor={greyColor}
                          innerSpace='10px 12px'
                          onButtonClick={cancelHandler}
                        />
                      </div>
                    ) : (
                      <GlobalButton
                        title='Edit'
                        textColor={SecondaryColor}
                        bgColor='#fff'
                        outlineColor={SecondaryColor}
                        innerSpace='10px 10px'
                        IconLeft={<EditIcon />}
                        buttonClassName='edit-btn'
                        onButtonClick={editHandler}
                      // disabled={detailsLoading}
                      />
                    )
                  }

                  {!isFreeUser() && (
                    <div className="share-btn-wrapper">
                      <ShareGroupPeopleModal
                        onClickHandler={() => shareClusterHandler(true)}
                        onCancelHandler={() => shareClusterHandler(false)}
                        iconMode
                        isDetailPage
                        inClusterMode
                      />
                    </div>
                  )}
                  <GlobalButton
                    title='Add Account'
                    textColor='#fff'
                    bgColor={SecondaryColor}
                    outlineColor={SecondaryColor}
                    innerSpace='10px 16px'
                    buttonClassName='add-account-btn'
                    onButtonClick={addAccountHandler}
                  // disabled={detailsLoading}
                  />
                  <GlobalButton
                    title='Apply'
                    textColor='#fff'
                    bgColor={primaryColor}
                    outlineColor={primaryColor}
                    innerSpace='10px 10px'
                    buttonClassName='apply-btn'
                    onButtonClick={applyHandler}
                    disabled={selectedCompanies.length === 0 || editClicked}
                  />
                </div>
              </div>
              <div className='companies-section'>
                <Row
                  className="Grid-width-row white-layer-col"
                  gutter={[24, 24]}
                  style={{ margin: '0' }}
                >
                  {clusterCompanies.slice(0, 6).map((company) => {
                    // const isSelected = selectedCompanies.includes(company.companyId);
                    const isSelected = selectedCompanies.some(
                      (selected) =>
                        selected.companyId === company.companyId
                    );

                    return (
                      <Col
                        key={company.companyId}
                        xxl={{ span: 6 }}
                        xl={{ span: 6 }}
                        lg={{ span: 6 }}
                        className="gutter-row"
                      >

                        <div className="company-card-wrapper">
                          {!editClicked && (
                            <Checkbox
                              className="floating-checkbox"
                              checked={isSelected}
                              onChange={() =>
                                handleCompanySelect(company.companyId, company.companyName)
                              }
                            />
                          )}

                          <CompanyCardLarge
                            companyData={company}
                            removeButton={editClicked}
                            removed={companiesToRemove.includes(
                              company.companyId
                            )}
                            handleCompanyRemoved={() =>
                              handleCompanyRemoveSelect(
                                company.companyId
                              )
                            }
                          />
                        </div>
                      </Col>
                    );
                  })}
                </Row>
              </div>
            </div>
            {
              !applyCompanies ? (
                <div className='not-applied-section'>
                  <div className="icon">
                    <CompaniesSvg color='#0000' />
                  </div>
                  <div className='text'>
                    Select a company to view Insights and Engagement details.
                  </div>
                </div>
              ) : (
                <ClusterInsightSection
                  clusterId={clusterIdParsed}
                  handleHighlightClick={handleHighlightClick}
                  onGilroyClose={handleGilroyClose}
                />
              )
            }
          </div>
        ) : null
      }
      <DrawerAccountCluster
        toggleDrawer={toggleDrawer}
        mode="create"
        isAddDrawer={true}
      />
      <DrawerPeopleGroup
        openNewCreate={openCreateModal}
        setOpenNew={toggle}
        showNew={showNew}
        toggleShowNew={(bool: boolean) => setShowNew(bool)}
        disableDrop
        noButton
      />
      {
        showGlobalGilroy ? (
          <Gilroy gilroyStates={gilroyStates} gilroyActions={gilroyActions} seedPrompt={selectedStrategicHighlight} />
        ) : (
          null
        )
      }
    </Wrapper>
  );
};

export default ClusterDetailPage;